var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEraser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.788,
    height: 19.339,
    viewBox: "0 0 22.788 19.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e{fill:none;}.b{clip-path:url(#a);}.c{fill:#1a1311;}.d{fill:#080505;}.e{stroke:#1a1311;stroke-linecap:round;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22.788,
    height: 19.339,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.924 -0.31)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.924 0.31)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.526,1.569a1.368,1.368,0,0,1,.974.4l3.768,3.769a1.378,1.378,0,0,1,0,1.947L8.632,18.324H4.8L1,14.525,13.552,1.972a1.368,1.368,0,0,1,.974-.4m0-1a2.371,2.371,0,0,0-1.681.7L.293,13.817a1,1,0,0,0,0,1.415l4.093,4.092h4.66L19.975,8.4a2.375,2.375,0,0,0,0-3.361L16.207,1.265a2.371,2.371,0,0,0-1.681-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M15.23.293l5.718,5.718a1,1,0,0,1,0,1.414L13.274,15.1,6.142,7.967,13.816.293a1,1,0,0,1,1.414,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 17.689,
    transform: "translate(4.599 18.839)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEraser);
export default __webpack_public_path__ + "static/media/icon_Eraser.bc03f4dc7bfe76602c945157957aef24.svg";
export { ForwardRef as ReactComponent };